// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__22obV","title":"Images45_title__1Ck17","images":"Images45_images__lVk7F"};